// extracted by mini-css-extract-plugin
export default {"wrapper":"User-module__wrapper--fe27e","button":"User-module__button--cd97b"};